const BASEURL = window.forge_url + "/api";
const FPRGEURL = window.forge_url;
const TISUURL = window.tisu_url + "/api";
const TISUURLV3 = window.tisu_url_v3;
const BASEV3URL = window.basev3_url;
const IPV6_URL = 'https://api-v3-ipv6.speedtest.cn';
const NODES_URL = window.nodes_url;
const NEW_NODES_URL = window.new_nodes_url;
const APP_API_URL = window.app_api_url;
const WECHAT_URL = window.wechat_url;
const PRO_M_URl = window.pro_m_url
const NEW_TISU_FORGE_URL = window.new_tisu_forge_url + "/api"; // 提速相关业务 forge新域名
const NEW_TISU_V3_URL = window.new_tisu_v3_url; // 提速相关业务 v3新域名
export default {
    PRO_M_URl,
    NODES_URL,
    NEW_NODES_URL,
    IPV6_URL,
    BASEV3URL,
    TISUURL,
    BASEURL,
    NEW_TISU_FORGE_URL,
    NEW_TISU_V3_URL,

    policyInfoUrl: BASEV3URL + '/privacyPolicy/policyInfo',
    generalPrivacyUrl: PRO_M_URl + `/general-privacy`,
    generalTermsUrl: PRO_M_URl + `/general-terms`,
    locationInfo: BASEV3URL + '/ip',//用户位置查询
    speedTestSettings: BASEURL + '/speedtest/settings',//获取测速配置
    latestUrl: BASEV3URL + "/speed/ipLatest",//进行测速历史的查询
    appVersionUrl: BASEURL + '/v2/app/version',
    fiveGPhoneList: BASEURL + '/v2/5g/phone-list',
    get5gRankOperator: BASEURL + '/v2/5g/rank',
    hallUrl: BASEURL + '/v2/5g/hall',   //获取5G营业厅
    divisionLinkUrl: BASEURL + '/v2/balance/link',  //获取推荐分成分享链接或二维码
    balanceListV2Url: BASEURL + '/v2/balance/info', //获取推荐分成邀请列表
    divisionListUrl: BASEURL + '/v2/balance/getBalanceAd', //获取推荐分成邀请列表
    speedupQueryV3Url: NEW_TISU_V3_URL + "/speedUp/query", // 查询宽带状态
    speedupOpenUrl: TISUURL + "/v2/speedup/open",
    speedupReOpenUrl: NEW_TISU_FORGE_URL + "/v2/speedup/reopen?source=www", // 重拨
    speedupSubScribeUrl: NEW_TISU_V3_URL + "/speedUpOrder/store", //订阅提速
    adfreeSubScribeUrl: BASEV3URL + '/userVipOrder/store',//订阅去广告
    speedupPayUrl: NEW_TISU_V3_URL + "/pay",//支付
    payStatusUrl: NEW_TISU_V3_URL + "/pay/status", //通用支付状态查询
    smsVerifyCode: BASEV3URL + "/sms/send",  //获取验证码
    smsVerify: BASEURL + "/v2/sms-verify",  //验证验证码
    modifyPhone: BASEURL + "/v2/user/modify-phone", //修改个人手机号
    bindPhone: BASEURL + "/v2/user/bind-phone", //修改个人手机号
    checkPhoneBinding: BASEURL + "/v2/user/check-phone-binding", //查看当前手机号有没有注册账号
    adUrl: BASEURL + '/v2/show?type=web',  // 弹窗广告
    buriedPointUrl: BASEURL + '/v2/buried-point',   // 埋点
    groupBalanceUrl: BASEV3URL + "/wxBalance/groupBalance",//小程序排行榜的收益
    getCMCCPackages: BASEV3URL + "/Cmcc/getPackage",
    crossLoginUrl: FPRGEURL + '/cross-login',//手机号登录
    accountLoginUrl: FPRGEURL + '/account-login',//密码登录
    locationPhoneUrl: BASEURL + '/location/phone',//手机号位置
    speedupRecordUrl: BASEURL + '/v2/speedup/record',//消息滚动List
    emotionsJsonUrl: 'https://api.weibo.com/2/emotions.json',
    logoutUrl: FPRGEURL + '/cross-logout', // 退出登录
    nearbySpeedUrl: `${BASEV3URL}/speed/nearbySpeed`, // 附近网速报告
    appVersionLatestUrl: APP_API_URL + '/appVersion/latest',//获取app下载链接
    appVersionAppListUrl: APP_API_URL + '/appVersion/appList',//获取app拆分
    articlesUrl: BASEURL + '/v2/articles',//消息滚动List
    wechatMakeUrl: WECHAT_URL + '/api/v2/wechat/make-url', //微信的地址
    index5gVideosUrl: BASEURL + '/v2/web/5g-videos', //首页5G视频数据
    indexSponsorUrl: BASEURL + '/v2/web/sponsor', //网站首页合作伙伴数据
    privateOssUrl:`${BASEV3URL}/privateFile`, // oss私有地址
    videoStoreUrl : `${BASEURL}/v2/video/store`, // 保存数据
    videoMyStoreUrl : `${BASEURL}/v2/video/my-store`, // 保存数据
    videoSetUserUrl : `${BASEURL}/v2/video/set-user`, // 数据归为当前用户
    videoMySpeedUrl : `${BASEURL}/v2/video/my-speed`, // 获取测速记录
    videoMyDelUrl : `${BASEURL}/v2/video/del`, // 删除测速记录
    ispSatisfactionUrl:`${BASEV3URL}/ispSatisfaction/store`, // 满意度排行
    LogoutApplyUrl:`${BASEV3URL}/logout/apply`, // 注销申请
    LogoutProgressUrl:`${BASEV3URL}/logout/progress`, // 注销进度查询
    LogoutRecoverUrl:`${BASEV3URL}/logout/recover`, // 注销恢复
}



// WEBPACK FOOTER //
// ./resources/js/config/apiList.js